export const getInitialState = () => ({
  scopeUpdates: {},
});
